import React from 'react'
import Alert from './bootstrap/Alert'

const CommonTable = ({ columns, rows }) => {

    if (rows && rows.length > 0) {
        return (
            <table className='table table-modern table-hover'>
                <thead>
                    <tr >
                        {columns.map(c => {
                            return (
                                <th scope='col' key={c.label} style={{ width: "1%" }}>{c.label}</th>
                            )
                        })}
                    </tr>
                </thead>
                <tbody>
                    {rows.map(row => {
                        return (
                            <tr key={row.id}>
                                {
                                    columns.map(col => {
                                        return (
                                            <td key={col.value}>{row[col.value]}</td>
                                        )
                                    })
                                }
                            </tr>

                        )
                    })}

                </tbody>
            </table >
        )
    }

    return <div style={{ minHeight: 150, display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold", }}>
        <Alert
            icon='Info'
            isLight
            color='danger'
            borderWidth={0}
        >
            Veri bulunamadı.
        </Alert>
    </div>
}

export default CommonTable